import { ID } from "src/libs/interfaces/layouts";
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces";
import { useLandingStore } from "src/modules/pe-landing-module/data/store";
import updateSelectedPosition from "./updateSelectedPosition";

export default function  resetPosition( id: ID ) {
    const store                     = useLandingStore.getState()
    const elementType: SELECT_TYPE  = store.selectedType
    const sectionId: ID             = store.selectedLayer
    const sectionElement = document.querySelector(`.landing-section-container.landing-gap[id="${sectionId}"]`)
    if(!sectionElement) return 
    
    switch(elementType) {
        case SELECT_TYPE.FLOAT:
            const floatElement = sectionElement.querySelector(`[data-content-id="${id}"]`) 
            if(!floatElement) break 
            const floatPositionElement: HTMLDivElement | null = floatElement.closest(`.landing-edit-cont`)
            if(!floatPositionElement) break
            floatPositionElement.style.transform = `translateX(0) translateY(0) scale(1) rotate(0deg)`;
            floatPositionElement.style.opacity = `1` 
            setTimeout(() => {
                const rect = floatPositionElement.getBoundingClientRect()
                updateSelectedPosition(
                    {
                        id,
                        position : { 
                            rotate: 0, 
                            left: 0, 
                            top: 0, 
                            width: rect.width,
                            height: rect.height, 
                            scale: 1, 
                        }
                    },
                    elementType
                )                
                console.log(rect)
                
            }, 100, floatPositionElement)
            break
        case SELECT_TYPE.TITLE:
        case SELECT_TYPE.CONTENT:
        default:
            updateSelectedPosition(
                {
                    id,
                    position : { 
                        rotate: 0, 
                        left: 0, 
                        top: 0,  
                        scale: 1, 
                    }
                },
                elementType
            )
    }
    
}